module.exports = __webpack_public_path__ + "img/Uganda.065ffa66.svg";